module.exports = __webpack_public_path__ + "img/38a-config-usuario-grupos-form.c088b845.png";